import React, { useContext } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { connect } from 'react-redux'

import GeoContext from 'contexts/geoContext'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import {
  BnblSteps,
  bnblSwitchablePackageDurations,
} from 'components/OfferPage/BnblModal/utils'
import { BnblSwitchPackageDurationItem } from './BnblSwitchPackageDurationItem'
import BodyText from 'components/Luxkit/Typography/BodyText'

const BnblSwitchPackageDurationItems = styled.div`
  margin-top: ${rem(32)};
`

interface MappedProps {
  numberOfRooms: number;
  packageView: OfferPackageOptionView;
}

interface Props {
  offer: App.Offer;
  setStep: (step: BnblSteps) => void;
  selectedPackageUniqueKey: string;
  setSelectedPackageUniqueKey: (uniqueKey: string) => void;
}

function BnblSwitchPackageDurationStep({
  numberOfRooms,
  offer,
  packageView,
  selectedPackageUniqueKey,
  setSelectedPackageUniqueKey,
}: Props & MappedProps) {
  const { showTaxExclusivePrices } = useContext(GeoContext)

  // get all possible "switchable" package durations
  const switchablePackageDurations = bnblSwitchablePackageDurations(offer, packageView.package)

  const onSwitchPackageDuration = (_, newPackageUniqueKey: string) => {
    setSelectedPackageUniqueKey(newPackageUniqueKey)
  }

  return (
    <div>
      <BodyText variant="large"> This offer is available for the following lengths of stay:</BodyText>
      <BnblSwitchPackageDurationItems>
        {switchablePackageDurations.map(switchablePackage => {
          const {
            bonusInclusions = false,
            duration,
            price: packagePrice,
            propertyFees = 0,
            taxesAndFees = 0,
            uniqueKey,
          } = switchablePackage.package

          const pricePerRoom = (packagePrice + propertyFees) + (showTaxExclusivePrices ? taxesAndFees : 0)
          const totalPrice = pricePerRoom * numberOfRooms

          return (
            <BnblSwitchPackageDurationItem
              key={uniqueKey}
              bonusInclusions={!!bonusInclusions}
              checked={uniqueKey === selectedPackageUniqueKey}
              name={duration}
              nights={duration}
              onSwitchPackageDuration={(e) => onSwitchPackageDuration(e, uniqueKey)}
              price={totalPrice}
            />
          )
        })}
      </BnblSwitchPackageDurationItems>
    </div>
  )
}

function mapStateToProps(state: App.State, ownProps: Props): MappedProps {
  const bnblModalPackages = state.offer.bnblModal[ownProps.offer.id]
  const { numberOfRooms, packageView } = bnblModalPackages[0]

  return {
    numberOfRooms,
    packageView,
  }
}

export default connect(mapStateToProps)(BnblSwitchPackageDurationStep)
